import type { FilterMultiLayoutType } from "@/features/filters/components/filter-multi/filter-multi-form";
import type { FilterMultiType } from "../../types/filter-multi.type";
import { FilterMultiAutoupdate } from "./filter-multi-autoupdate";
import { FilterMultiFormWrapper } from "./filter-multi-form-wrapper";

type FilterMultiRequired = {
  filter: FilterMultiType;
  paramName: string;
  collapsible?: boolean | number | string;
  listWrapperClass?: string;
  type?: "checkbox" | "button";
  multiple?: boolean;
  stretch?: boolean;
  layout?: FilterMultiLayoutType;
  collapsibleButtonLabel?: string;
};

export type FilterMultiConditional =
  | { asForm: true; form: any }
  | { asForm?: false; form?: never };

export type FilterMultiProps = FilterMultiRequired & FilterMultiConditional;

export const FilterMulti = ({
  filter,
  paramName,
  collapsible = false,
  asForm = false,
  form,
  listWrapperClass,
  type = "checkbox",
  multiple = true,
  stretch = false,
  layout = "default",
  collapsibleButtonLabel,
}: FilterMultiProps) => {
  return asForm ? (
    <FilterMultiFormWrapper
      filter={filter ?? {}}
      paramName={paramName ?? ""}
      collapsible={collapsible}
      form={form}
      listWrapperClass={listWrapperClass}
      type={type}
      multiple={multiple}
      stretch={stretch}
      layout={layout}
      collapsibleButtonLabel={collapsibleButtonLabel}
    />
  ) : (
    <FilterMultiAutoupdate
      filter={filter ?? {}}
      paramName={paramName ?? ""}
      collapsible={collapsible}
      listWrapperClass={listWrapperClass}
      type={type}
      multiple={multiple}
      stretch={stretch}
      layout={layout}
      collapsibleButtonLabel={collapsibleButtonLabel}
    />
  );
};
